<template>
  <div class="stats-container">
    <div class="stats-content">
      <h1 class="stats-title">Statistics</h1>

      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-number">{{ stats.total }}</div>
          <div class="stat-label">Total Attempts</div>
        </div>

        <div class="stat-card">
          <div class="stat-number">{{ accuracy }}%</div>
          <div class="stat-label">Accuracy</div>
        </div>

        <div class="stat-card">
          <div class="stat-number correct-color">{{ stats.correct }}</div>
          <div class="stat-label">Correct</div>
        </div>

        <div class="stat-card">
          <div class="stat-number incorrect-color">{{ stats.incorrect }}</div>
          <div class="stat-label">Incorrect</div>
        </div>
      </div>

      <button @click="resetStats" class="reset-button">Reset Statistics</button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

const stats = ref({
  total: 0,
  correct: 0,
  incorrect: 0,
});

const accuracy = computed(() => {
  if (stats.value.total === 0) return 0;
  return Math.round((stats.value.correct / stats.value.total) * 100);
});

const loadStats = () => {
  const savedStats = localStorage.getItem("stats");
  if (savedStats) {
    stats.value = JSON.parse(savedStats);
  }
};

const resetStats = () => {
  if (confirm("Are you sure you want to reset all statistics?")) {
    stats.value = {
      total: 0,
      correct: 0,
      incorrect: 0,
    };
    localStorage.setItem("stats", JSON.stringify(stats.value));
  }
};

onMounted(() => {
  loadStats();
});
</script>

<style scoped>
.stats-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 20px;
}

.stats-content {
  text-align: center;
  max-width: 600px;
  width: 100%;
}

.stats-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 40px;
  transition: color 0.3s ease;
}

.dark-mode .stats-title {
  color: #e0e0e0;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: #f8f8f8;
  padding: 30px 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.dark-mode .stat-card {
  background: #1a1a1a;
}

.stat-card:hover {
  transform: translateY(-4px);
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  transition: color 0.3s ease;
}

.dark-mode .stat-number {
  color: #e0e0e0;
}

.stat-number.correct-color {
  color: #2e7d32;
}

.dark-mode .stat-number.correct-color {
  color: #81c784;
}

.stat-number.incorrect-color {
  color: #c62828;
}

.dark-mode .stat-number.incorrect-color {
  color: #e57373;
}

.stat-label {
  font-size: 0.9rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.dark-mode .stat-label {
  color: #999;
}

.reset-button {
  background-color: #1a1a1a;
  color: white;
  border: none;
  padding: 16px 40px;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.reset-button:hover {
  background-color: #333;
  transform: translateY(-1px);
}

.dark-mode .reset-button {
  background-color: #e0e0e0;
  color: #0f0f0f;
}

.dark-mode .reset-button:hover {
  background-color: #ffffff;
}
</style>
